import { render, staticRenderFns } from "./ThemeAdd.vue?vue&type=template&id=8d99a4fe&scoped=true"
import script from "./ThemeAdd.vue?vue&type=script&lang=js"
export * from "./ThemeAdd.vue?vue&type=script&lang=js"
import style0 from "./ThemeAdd.vue?vue&type=style&index=0&id=8d99a4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d99a4fe",
  null
  
)

export default component.exports